import { gql } from "@apollo/client"

const SEARCH_FIELDS = gql`
  fragment SearchFields on SearchResult {
    id
    title
    scheduleName
    processName
    displayName
    type
    date
    score
    organisation
    createdAt
    updatedAt
  }
`

const JOB_SEARCH_FIELDS = gql`
  fragment JobSearchFields on JobSearchResult {
    id
    title
    scheduleName
    processName
    displayName
    type
    date
    score
    organisation
    createdAt
    updatedAt
    status {
      completed
      submitted
      steps {
        ... on CheckboxJobStep {
          completedAt
          responseType
        }
        ... on NumberJobStep {
          completedAt
          responseType
        }
        ... on NumberRatingJobStep {
          completedAt
          responseType
        }
        ... on TextJobStep {
          completedAt
          responseType
        }
        ... on LongTextJobStep {
          completedAt
          responseType
        }
        ... on DateTimeJobStep {
          completedAt
          responseType
        }
        ... on PhotosJobStep {
          completedAt
          responseType
        }
        ... on MultipleChoiceJobStep {
          completedAt
          responseType
        }
        ... on ProcessJobStep {
          completedAt
          responseType
        }
        ... on RandomizerJobStep {
          completedAt
          responseType
        }
        ... on SignatureJobStep {
          completedAt
          responseType
        }
        ... on SectionJobStep {
          responseType
        }
        ... on InstructionJobStep {
          responseType
        }
        ... on FilesJobStep {
          completedAt
          responseType
        }
        ... on SelectionJobStep {
          completedAt
          responseType
        }
        ... on TemperatureTimerJobStep {
          completedAt
          responseType
        }
      }
    }
    dueAt
    isOverdue
  }
`

const ACTION_SEARCH_FIELDS = gql`
  fragment ActionSearchFields on ActionSearchResult {
    id
    title
    scheduleName
    processName
    displayName
    type
    date
    score
    organisation
    createdAt
    updatedAt
    priority
    dueAt
    status
  }
`

const KNOWLEDGE_BASE_SEARCH_FIELDS = gql`
  fragment KnowledgeBaseSearchFields on KnowledgeBaseSearchItem {
    id
    title
    date
    type
    category
    score
  }
`

export { SEARCH_FIELDS, JOB_SEARCH_FIELDS, ACTION_SEARCH_FIELDS, KNOWLEDGE_BASE_SEARCH_FIELDS }
